import { types } from '../../../constants/ActionTypes'

const initialState = {
}

const turnSelectMenu = (state = initialState, action) => {
  const { bid } = action
  switch (action.type) {
    case types.turnSelectMenu.OPEN:
      return { ...state, [bid]: { ...state[bid], anchorEl: action.anchorEl } }
    case types.turnSelectMenu.CLOSE:
      return { ...state, [bid]: { ...state[bid], anchorEl: null } }
    default:
      return state
  }
}

export default turnSelectMenu



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/TurnSelectMenu.js